// This file is auto generated
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();export const spriteHref = "8f8cf38a437bc75906548ad672cf9033.svg";
export type SymbolName =
  | "amex"
  | "apple-pay"
  | "authenticity"
  | "google-pay"
  | "ideal"
  | "instagram"
  | "linked-in"
  | "mastercard"
  | "qogita"
  | "qogita-logomark"
  | "qogitaSellersV2"
  | "qogitaV2"
  | "twitter"
  | "union-pay"
  | "visa";
